<template>
  <v-container
    ref="container"
    class="fill-height page"
    fluid
  >
    <div class="overlay" />

    <v-row
      class="f-flex"
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Se connecter</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="info.username"
                label="Courriel"
                name="username"
                prepend-icon="mdi-account"
                type="text"
              />

              <v-text-field
                id="password"
                v-model="info.password"
                label="Mot de passe"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                @keyup.enter.prevent="login"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              dark
              :loading="inProgress"
              @click="login()"
            >
              Valider
            </v-btn>
          </v-card-actions>

          <v-divider class="ma-4" />
          <p class="text-center ma-5 font-italic">
            Pas besoin de créer un nouveau compte si vous avez déjà participé à l'édition 2023 ou précédentes.
            Vous pouvez vous connecter directement avec vos identifiants pour vous inscrire à l'édition 2024.
          </p>

          <v-card-actions class="d-flex justify-center">
            <div>
              Pas encore de compte ?
            </div>
            <v-btn
              text
              @click="$router.push('/account/signin')"
            >
              Créer mon compte
            </v-btn>
          </v-card-actions>

          <div class="d-flex justify-center">
            <v-btn
              text
              @click="$router.push('/account/password/request')"
            >
              J'ai perdu mon de passe
            </v-btn>
          </div>

          <v-alert
            v-if="hasError"
            dense
            outlined
            type="error"
            class="ma-3"
          >
            {{ hasError }}
          </v-alert>
          <br>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { AbilityBuilder } from '@casl/ability'

  import { mapGetters } from 'vuex'

  export default {
    auth: false,
    layout: 'empty',
    data: () => ({
      inProgress: false,
      hasError: '',
      info: {
        username: '',
        password: '',
      },
    }),
    computed: {
      ...mapGetters('style', ['primaryColor', 'title', 'secondaryColor']),
    },
    mounted () {
    // console.log(this.$auth.loggedIn)
    // this.$refs.container.style.backgroundImage = `url(${this.$storage.url('minio', 'assets/login-bg.jpg?height=32')})`
    },
    methods: {
      login () {
        this.inProgress = true
        this.hasError = ''
        this.$auth.login({
          user: this.info.username,
          pass: this.info.password,
        })
          .then(() => {
            this.inProgress = false
            this.$router.push('/')
          })
          .catch((err) => {
            this.inProgress = false
            this.hasError = 'Le nom d\'utilisateur ou le mot de passe semble incorrect'
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
.page {
  padding: 0!important;
  position: relative;
  background-position: center;
  background-size: cover;
  background-image: url('https://imaginary.service.codeisalie.fr/resize?height=80&url=https://storage.service.lecalamedor.fr/strapi/DSC_0173_5f06dace78.JPG');
}
.overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  height:100%;
  width:100%
}
</style>
